"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'user.form.language.label': 'Język',
    'user.form.language.placeholder': 'Wybierz język',
    'user.form.userGroup.label': 'Grupa Użytkowników',
    'user.form.userGroup.placeholder': 'Wybierz grupę użytkowników',
    'user.form.userGroup.show': 'Pokaż Grupy Użytkowników',
    'user.form.userGroup.add': 'Dodaj nową grupę użytkowników',
    'user.form.userGroup.search_placeholder': 'Szukaj grup użytkowników...',
    'user.form.title.edit': 'Edytuj Użytkownika',
    'user.form.title.add': 'Dodaj Użytkownika',
    'user.form.back': 'Wstecz',
    'user.form.name.label': 'Imię',
    'user.form.name.placeholder': 'Jan',
    'user.form.last_name.label': 'Nazwisko',
    'user.form.last_name.placeholder': 'Kowalski',
    'user.form.username.label': 'Login',
    'user.form.username.placeholder': 'jankowalski',
    'user.form.email.label': 'Email',
    'user.form.email.placeholder': 'email@adres.com',
    'user.form.password.label': 'Hasło',
    'user.form.password.new.label': 'Nowe Hasło (zostaw puste, aby zachować obecne)',
    'user.form.password.placeholder': 'Hasło',
    'user.form.password.repeat.label': 'Powtórz Hasło',
    'user.form.password.repeat.new.label': 'Powtórz Hasło (zostaw puste, aby zachować obecne)',
    'user.form.password.repeat.placeholder': 'Powtórz Hasło',
    'user.form.role.label': 'Rola',
    'user.form.role.placeholder': 'Wybierz rolę',
    'user.form.active.label': 'Aktywny',
    'user.form.companies.label': 'Przypisane firmy',
    'user.form.companies.placeholder': 'Wybierz firmy',
    'user.form.company.label': 'Firma',
    'user.form.company.placeholder': 'Wybierz firmę...',
    'user.form.submit.update': 'Aktualizuj Użytkownika',
    'user.form.submit.create': 'Utwórz Użytkownika',
    'user.form.acl.loadError': 'Błąd ładowania metadanych ACL:',
    'user.form.load.debug': 'Ładowanie użytkownika:',
    'user.form.load.error': 'Błąd ładowania użytkownika',
    'user.form.submit.updateError': 'Błąd aktualizacji użytkownika',
    'user.form.submit.createError': 'Błąd tworzenia użytkownika',
    'user.form.submit.updateSuccess': 'Użytkownik został pomyślnie zaktualizowany',
    'user.form.submit.createSuccess': 'Użytkownik został pomyślnie utworzony',
    'user.form.preview.title': 'Podgląd Dostępu',
    'user.form.preview.selectedGroup': 'Wybrana Grupa',
    'user.form.preview.permissions': 'Uprawnienia',
    'user.form.preview.selectGroup': 'Wybierz grupę użytkowników, aby podejrzeć uprawnienia dostępu',
    'user.form.preview.noAccess': 'Brak dostępnych uprawnień dostępu',
    'user.form.error.userGroup_required': 'Wybór grupy użytkowników jest wymagany',
};
